const treasureGoblin = `

#### Open the Portal and Enter
- Killing **monsters** all over the world gives you a chance to encounter a **Treasure Goblin**.

![Treasure Goblin](assets/guide/schatzgoblin.png)

#### Portal Activation
- Defeating a **Treasure Goblin** has a **15% chance** to spawn a portal to the **Realm of Treasures**.
- If a portal appears, the **player who landed the final hit** receives a **Portal Key**.
- **You have 30 seconds** to enter the portal.

![Portal](assets/guide/portal.png) ![Portal Key](assets/guide/portalkey.png)

#### Inside the Realm of Treasures
- **Treasure Guards** await you – **defeat them** to proceed.

![Treasure Guards](assets/guide/wachterderschatze.png)

- After defeating the guards, a **Treasure Chest** will appear.
- The **King of Treasures** will spawn as the final boss.

![King of Treasures](assets/guide/konigrderschatze.png)

#### The Final Reward
- Defeat the **King of Treasures** to unlock a **big treasure chest**.

![Treasure Chest](assets/guide/schatzkiste.png)

#### Rewards List (Coming Soon)
- A list of obtainable items will be **updated soon**.
- **Preview:**

![Treasure Rewards](assets/guide/reichderschaetze_kisten_us.png)

Enjoy your adventure in the **Realm of Treasures**! 🎉`;

export default treasureGoblin;
